// extracted by mini-css-extract-plugin
export var organized = "style-module--organized--38e9c";
export var organized__blockItem = "style-module--organized__block-item--45df9";
export var organized__title = "style-module--organized__title--1a79f";
export var whom = "style-module--whom--ddf7e";
export var whom__block = "style-module--whom__block--6a1c5";
export var whom__img = "style-module--whom__img--aa06a";
export var whom__imgVideo = "style-module--whom__img-video--a4fee";
export var whom__point = "style-module--whom__point--b5fb2";
export var whom__points = "style-module--whom__points--032e6";